import cx from 'classnames'

import { Icons } from 'src/common/components'
//TODO - fix this
import checkboxStyles from 'src/common/components/form/Checkbox/checkbox.module.scss'
import { IOption } from 'src/common/interfaces'

import styles from './basic-multi-select-groups-options.module.scss'

interface BasicMultiSelectGroupsOptionsProps {
  options: IOption[]
  currentValue: string[]
  onChange: (newValue: string) => void
}

const BasicMultiSelectGroupsOptions = (
  props: BasicMultiSelectGroupsOptionsProps,
) => {
  const { options, currentValue, onChange } = props

  return (
    <div className={styles.wrapper}>
      {options.map((option) => (
        <div
          key={option.value}
          className={styles.option}
          onClick={() => onChange(option.value)}
        >
          <div className={checkboxStyles.wrapper}>
            <span
              className={cx(
                checkboxStyles.inner,
                styles.checkboxInner,
                currentValue.includes(option.value) && checkboxStyles.checked,
              )}
            >
              <Icons.Check />
            </span>
          </div>
          <span>{option.label}</span>
        </div>
      ))}
    </div>
  )
}

export default BasicMultiSelectGroupsOptions
